// Generated by ts-to-zod
import {z} from "zod";

export const mantinePieChartPropsSchema = z.object({
	h: z.number().optional(),
});
